/** @format */

import React, { useEffect, useState } from "react";

import Table1 from "./Table1";
import Table2 from "./Table2";
import Table3 from "./Table3";
import Table4 from "./Table4";
import Table5 from "./Table5";
import Table6 from "./Table6";
import Tabs from "../../components/Tabs";
import ContentTop from "../../components/ContentTop";
import { monthName } from "../../../../components/functions/Month";

const formatTopDateLabel = (date, isMonthly) => {
  if (!date) {
    return "";
  }

  if (isMonthly) {
    return `${date.slice(0, 4)} ${monthName(date)} oyi`;
  }

  return `${date.split("-").reverse().join(".")} kun holatiga`;
};

const SuvomborlariSahifa = ({ setOmbor }) => {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);
  const [toggle, setToggle] = useState(1);
  const [loading, setLoading] = useState(false);
  const isMonthlyReport = toggle === 5 || toggle === 6;

  const tabs = [
    { title: "Hisob-kitob", id: 1, type: "text" },
    { title: "MChS", id: 2, type: "text" },
    { title: "SO lar Asosiy", id: 3, type: "text" },
    { title: "SO tahlili Viloyatlar kesimida", id: 4, type: "text" },
    { title: "Oylik hisobot", id: 5, type: "text" },
    { title: "Dekada", id: 6, type: "text" },
  ];
  useEffect(() => {}, [date]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left suv-omborlari' style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <li style={{ fontWeight: "600", fontSize: "16px", whiteSpace: "nowrap" }}>
            Suv omborlari bo'yicha ko'rsatkichlar
            <span style={{ color: "#7e8299", fontSize: "13px", marginLeft: "8px", fontWeight: "400" }}>
        ({formatTopDateLabel(ldate, isMonthlyReport)})
      </span>
          </li>
          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <ul className='content-top-right'>
          <input
              type={isMonthlyReport ? "month" : "date"}
              className='form-control form-control-sm'
              value={isMonthlyReport ? ldate.slice(0, 7) : ldate}
              onChange={(e) => {
                const value = e.target.value;
                setLdate(isMonthlyReport && value ? `${value}-01` : value);
              }}
          />
        </ul>
      </ContentTop>

      <div className='tabs-content table-box'>
        <div
          className={
            toggle === 1 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table3
            date={date}
            setOmbor={setOmbor}
            loading={loading}
            setLoading={setLoading}
          />
        </div>

        <div
          className={
            toggle === 2 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table2
            date={date}
            setOmbor={setOmbor}
            loading={loading}
            setLoading={setLoading}
          />
        </div>

        <div
          className={
            toggle === 3 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table1
            date={date}
            setOmbor={setOmbor}
            loading={loading}
            setLoading={setLoading}
          />
        </div>

        <div
          className={
            toggle === 4 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table4
            date={date}
            setOmbor={setOmbor}
            loading={loading}
            setLoading={setLoading}
          />
        </div>

        <div
          className={
            toggle === 5 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table6
            date={date}
            setOmbor={setOmbor}
            loading={loading}
            setLoading={setLoading}
          />
        </div>

        <div
          className={
            toggle === 6 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table5
            date={date}
            setOmbor={setOmbor}
            loading={loading}
            setLoading={setLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default SuvomborlariSahifa;
